// extracted by mini-css-extract-plugin
export default {"header":"styles_header__KFwV+","headerIcon":"styles_headerIcon__n8Gsq","ios":"styles_ios__UcP+-"};